import { render, staticRenderFns } from "./TransferPayments.vue?vue&type=template&id=dd272510&scoped=true&"
import script from "./TransferPayments.vue?vue&type=script&lang=js&"
export * from "./TransferPayments.vue?vue&type=script&lang=js&"
import style0 from "./TransferPayments.vue?vue&type=style&index=0&id=dd272510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd272510",
  null
  
)

export default component.exports